import { BCMSDefaultModel, BCMSRecord, useGlobalController, useParams, useRouteData, Workflow } from "@bcm-dev/bcms-vite";
import AddManageBillerPage from "compid/pages/AddManageBillerPage";
import SearchBillerPage from "compid/pages/SearchBillerPage";
import { AddBiller, Bill, Biller } from "model";

// Steps of the workflow
const steps = {
    "/searchBiller" : <SearchBillerPage />,
    "/addManageBiller" : <AddManageBillerPage />
};

export default function AddBillerWorkflow(props) {
    const controller = useGlobalController();
    const { billerID, stepID } = useParams();
   
    const  route  = useRouteData()
    const routeData = route !== null ? route.route : {};
    // Get the default data for the workflow
    const value = getDefaultBiller(controller, billerID);
    
    const constructor = value => {
        const { biller, bill } = getDefaultBiller(controller, billerID);
        const billerValues = { ...biller.record, ...value };

        return { biller: Biller.init(billerValues), bill };
    }

    return <Workflow value={ value } steps={ Object.values(steps) } step={ stepID } constructor={ constructor } />;
}

// Return the workflowSteps
export const getWorkflowSteps = () => steps;

// Return the default data for the workflow
export const getDefaultBiller = (controller, billerID) => {
    BCMSRecord.globalControllerFor([ Biller, AddBiller, Bill ], controller);
   
    const biller = billerID !== undefined ? AddBiller.initByID(billerID) : AddBiller.init({});
    const bill = BCMSDefaultModel.bill();

    biller.number = "";
    biller.nickname = "";
    biller.zip = "";

    return { biller, bill };
}